import * as mutationType from "../mutation_types";
import moment from "moment";

const state = {
  overview: {},
  pending: []
};

const getters = {
  overview: state => state.overview,
  pending: state => state.pending
};

const actions = {
  getReviewOverview({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/reviews`)
        .then(res => {
          commit(mutationType.SET_REVIEW_OVERVIEW, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPendingReviews({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/reviews/pending`)
        .then(res => {
          commit(mutationType.SET_PENDING_REVIEWS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveReviewAnswer({ commit }, review) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/reviews/${review.id}/answer`, review)
        .then(() => {
          commit(mutationType.SET_PENDING_REVIEW_ANSWER, review);
          commit(`checkin/${mutationType.SET_CHECKIN_REVIEW_ANSWER}`, review, {
            root: true
          });
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveReviewFeedback({ commit }, review) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/reviews/${review.id}/feedback`, review)
        .then(() => {
          commit(mutationType.SET_PENDING_REVIEW_FEEDBACK, review);
          commit(
            `checkin/${mutationType.SET_CHECKIN_REVIEW_FEEDBACK}`,
            review,
            {
              root: true
            }
          );
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_REVIEW_OVERVIEW](state, overview) {
    state.overview = overview;
  },
  [mutationType.SET_PENDING_REVIEWS](state, list) {
    state.pending = list;
  },
  [mutationType.SET_PENDING_REVIEW_ANSWER](state, review) {
    let index = state.pending.findIndex(x => x.id == review.id);
    if (index >= 0) {
      state.pending[index].answer = review.answer;
      state.pending[index].answerText = review.answerText;
      state.pending[index].completeDate = moment();
    }
  },
  [mutationType.SET_PENDING_REVIEW_FEEDBACK](state, review) {
    let index = state.pending.findIndex(x => x.id == review.id);
    if (index >= 0) {
      state.pending[index].feedback = review.feedback;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
